import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Modal } from '@decisiv/ui-components';
import { P } from '@decisiv/ui-components/lib/components/Typography';
import ArchiveArrowUp from '@decisiv/iconix/lib/components/ArchiveArrowUp';
import { Trans, t } from '@lingui/macro';
import noop from 'lodash/noop';
import WrapperWithLoading from '../../components/WrapperWithLoading';

const RestoreModal = ({
  visible,
  loading = false,
  integrationName = '',
  onRestore,
  onClose,
}) => (
  <Modal
    actions={[
      {
        text: t`Restore Integration`,
        onClick: onRestore,
        disabled: loading,
        loading,
      },
      { text: t`Cancel`, onClick: onClose, disabled: loading },
    ]}
    icon={ArchiveArrowUp}
    onClose={loading ? noop : onClose}
    title={t`Restore Integration`}
    visible={visible}
  >
    {loading ? (
      <WrapperWithLoading
        loading={loading}
        description={<Trans>Restoring Integration</Trans>}
      />
    ) : (
      <Flex flexDirection="column" marginTop={1}>
        <P shade={1}>
          <Trans>
            After clicking RESTORE INTEGRATION, {integrationName} will be moved
            out of the archive and made active again. Its locations are restored
            in the state they had when the integration was archived.
          </Trans>
        </P>
      </Flex>
    )}
  </Modal>
);

RestoreModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  integrationName: PropTypes.string,
  onRestore: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default RestoreModal;
